import { Divider } from "@msuite/ui/divider";
import { FormSwitch, NumberInput, Textarea, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { ArticleProductTypeFormSchema } from "@msuite/utils/schemas";
import { Fragment } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { ArticleGroupSelect } from "@/components/stock";
import { useMentionOptions } from "@/hooks/use-mention-options";

export function ArticleProductTypeForm() {
	/** Context */
	const methods = useFormContext<ArticleProductTypeFormSchema>();
	const [autoGenerateNumber] = useWatch({
		control: methods.control,
		name: ["autoGenerateNumber"],
	});

	/** Hooks */
	const { t } = useTranslation();
	const mentionOptions = useMentionOptions();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<ArticleGroupSelect
				control={methods.control}
				name="articleGroupId"
			/>
			<FormSwitch
				control={methods.control}
				name="autoGenerateNumber"
			>
				{t("stock.auto_generate_number")}
			</FormSwitch>
			{!autoGenerateNumber ? (
				<Fragment>
					<NumberInput
						label={t("stock.order_no")}
						isRequired
						control={methods.control}
						name="number"
						placeholder="1"
						min={0}
						max={999}
						step={1}
						variant="integer"
					/>
					<Divider />
				</Fragment>
			) : null}
			<TextInput
				label={t("general.name")}
				name="name"
				isRequired
				control={methods.control}
				placeholder={t("placeholders.stock.article_product_type_name")}
			/>
			<Textarea
				disableFormatting
				isRequired={false}
				label={t("general.description")}
				control={methods.control}
				name="description"
				{...mentionOptions}
			/>
		</div>
	);
}
